export const selector = 'dbANumberOnly';

/* @ngInject */
export default function NumberOnlyDirective($parse, numberUtil) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link(scope, element, attrs, ctrl) {
            let getIntegerOnly = () => attrs.integerOnly != null;
            let getAllowInvalid = () => attrs.allowInvalid != null;
            let getMin = $parse(attrs.ngMin);
            let getMax = $parse(attrs.ngMax);

            ctrl.$parsers.push(parser);

            element.on('blur', blurHandler);
            scope.$on('$destroy', () => element.off('blur', blurHandler));

            function parser(value) {
                let fixedValue = fixValue(value);
                
                if (numberUtil.isNumeric(value) && value !== fixedValue) {
                    render(fixedValue);
                }

                return fixedValue;
            }

            function blurHandler() {
                render(fixValue(ctrl.$viewValue));
            }

            function fixValue(value) {
                let min = getMin(scope);

                if (numberUtil.isNumeric(value)) {
                    let max = getMax(scope);

                    if (numberUtil.isNumeric(min) && value < min) {
                        value = min;
                    } else if (numberUtil.isNumeric(max) && value > max) {
                        value = max;
                    }

                    value = getIntegerOnly() ? parseInt(value) : value;
                } else if (!getAllowInvalid() || value != null && `${value}`.length > 0) {
                    value = fixValue(numberUtil.numberify(value || min));
                }

                return value;
            }

            function render(value) {
                ctrl.$setViewValue(value);
                ctrl.$render();
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/number-only/number-only.directive.js